const EXCHANGE_DISPLAY_NAMES: Record<string, string> = {
  forecastex: 'ForecastEx',
  forecastx: 'ForecastEx',
  kalshi: 'Kalshi',
  cme: 'CME Group',
};

export function getExchangeDisplayName(code: string): string {
  return EXCHANGE_DISPLAY_NAMES[code.toLowerCase()] ?? code;
}

export function getExchangeDisplayNames(codes: string[]): string {
  const seen = new Set<string>();
  const names: string[] = [];
  for (const code of codes) {
    const name = getExchangeDisplayName(code);
    if (!seen.has(name)) {
      seen.add(name);
      names.push(name);
    }
  }
  return names.join(', ');
}
